import { RefundCreditCardTransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useRefundCreditCardTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  async function refundCreditCardTransaction(params: RefundCreditCardTransactionRequest) {
    try {
      setFetching(true);
      const res = await api.postRefundCreditCardTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, refundCreditCardTransaction };
}
